import styled from "@emotion/styled";
import { EventPresenter, eventPresenterClasses } from "@kaltura/mediaspace-shared-event-platform-event-list";
import { Box } from "@kaltura/mediaspace-shared-styled";
import { VisibleFocusStyle } from "@kaltura/ds-react-theme";
import { Link } from "@kaltura/ds-react-components";

export const StyledPresenterContainer = styled(Box)(({ theme }) => ({
    "& > a": {
        textDecoration: "none",
        display: "block",
    },
    "& > div > a": {
        textDecoration: "none",
    },
}));

export const StyledPresenter = styled(EventPresenter)(({ theme }) => ({
    [`.${eventPresenterClasses.details}`]: {
        marginTop: "auto",
        marginBottom: "auto",
    },
    "&:focus-visible": VisibleFocusStyle,
}));

export const StyledLink = styled(Link)({
    display: "block", // allows text to wrap and works in both layouts
    minWidth: 0, // ensures children can shrink/wrap
    width: "100%", // makes link fill container
});
